import { itemsOfKind, tuning, type CatalogId, type FishEntry, type FossilEntry, type ItemEntry } from '@whiskerton/content';
import { catalogLookup, type Lookup } from './lookup';

export const UNKNOWN_FOSSIL = 'fossil.unknown';

export function canDonate(catalogId: CatalogId, donated: ReadonlySet<CatalogId>, lookup: Lookup = catalogLookup):
  'ok' | 'already_donated' | 'not_donatable' | 'unidentified' {
  if (catalogId === UNKNOWN_FOSSIL) return 'unidentified';
  const e = lookup(catalogId);
  if (!e || (e.kind !== 'fish' && e.kind !== 'fossil')) return 'not_donatable';
  if (e.kind === 'fossil' && e.set === '') return 'unidentified';
  return donated.has(catalogId) ? 'already_donated' : 'ok';
}

const hallPool = (kind: 'fossil' | 'fish', pool?: readonly ItemEntry[]): readonly ItemEntry[] =>
  (pool ?? itemsOfKind(kind)).filter((e) => e.kind === kind && !(e.kind === 'fossil' && e.set === ''));

export function hallComplete(kind: 'fossil' | 'fish', donated: ReadonlySet<CatalogId>, pool?: readonly ItemEntry[]): boolean {
  const entries = hallPool(kind, pool);
  return entries.length > 0 && entries.every((e) => donated.has(e.id));
}

export function fossilSets(pool: readonly FossilEntry[] = itemsOfKind('fossil')): { set: string; parts: CatalogId[] }[] {
  const by = new Map<string, FossilEntry[]>();
  for (const f of pool) if (f.set !== '') by.set(f.set, [...(by.get(f.set) ?? []), f]);
  return [...by.entries()]
    .map(([set, parts]) => ({ set, parts: [...parts].sort((a, b) => a.hallOrder - b.hallOrder) }))
    .sort((a, b) => a.parts[0]!.hallOrder - b.parts[0]!.hallOrder)
    .map(({ set, parts }) => ({ set, parts: parts.map((p) => p.id) }));
}

export function museumTank(fish: Pick<FishEntry, 'habitat' | 'shadow'>): 'river' | 'pond' | 'sea' | 'feature' {
  return fish.shadow >= tuning.museum.featureTankMinShadow ? 'feature' : fish.habitat;
}
